
import React from 'react';

import Repos from './Repos';

export default () => (
  <div>
    <p>
      An example e-commerce app. Features:
    </p>
    <ul>
      <li>a <a href="http://rubyonrails.org/">Ruby on Rails</a> app</li>

      <li>
        responsive design using
        {' '}<a href="https://getbootstrap.com/">Bootstrap</a>
        {' '}and
        {' '}<a href="https://jquery.com/">jQuery</a>
      </li>

      <li>a user sign up system using <a href="https://github.com/plataformatec/devise">Devise</a></li>

      <li>test framework using <a href="http://rspec.info/">RSpec</a></li>

      <li>
        a working payment system using <a href="https://stripe.com/">Stripe</a>
        {' '}(use credit card number 4242424242424242 to test)
      </li>

      <li>
        a collection of Rake tasks for deployment to <a href="https://www.heroku.com/">Heroku</a>
        {' '}or any server
      </li>

      <li>
        database: PostgreSQL
      </li>
    </ul>

    <p>
      <Repos repos={[{
        href: 'https://github.com/michael-software-engr/ecommerce',
        text: 'michael-software-engr/ecommerce'
      }]} />
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/projects/descriptions/ECommerce.js